<template>
  <v-container id="my-groups" fluid tag="section">
    <v-overlay :value="isOverlayVisible">
      <v-progress-circular
        :size="70"
        :width="7"
        color="amber"
        indeterminate
        class="spinner"
      />
    </v-overlay>

    <template>
      <v-toolbar flat color="transparent">
        <v-select
          v-model="selectedFilterId"
          class="filterSelector"
          :items="[
            { groupFilterType: 'All', groupFilterTypeID: -1 },
            ...filterTypes,
          ]"
          label="Select Filter"
          item-text="groupFilterType"
          item-value="groupFilterTypeID"
        />
        <!-- <v-spacer /> -->
        <v-select
          v-model="selectedFilterType"
          class="filterSelector"
          :items="types"
          label="Select Group Type"
          item-text="typeLabel"
          item-value="value"
        />
        <v-spacer />
        <v-spacer />
        <v-spacer />

        <v-btn
          v-if="isAdmin"
          color="primary"
          dark
          class="mb-2 ml-4"
          @click="_showAddGroupDialog"
        >
          <v-icon small class="mr-2"> mdi-plus </v-icon>
          New Dynamic Group
        </v-btn>
      </v-toolbar>
    </template>

    <v-data-table
      :headers="headers"
      :items="filteredGroups"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:[`item.System`]="{ item }">
        <div class="tickerWrapper" v-if="item.System">
          <div class="systemTemplateTicker">System</div>
        </div>
        <div class="tickerWrapper" v-if="!item.System">
          <div class="userTemplateTicker">Practice</div>
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="senderActions">
          <div class="commBtnWrapper">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showIvrCallInitiator(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-phone</v-icon>
                </button>
              </template>
              <span>Initiate IVR</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showBulkEmailComposer(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-email-edit</v-icon>
                </button>
              </template>
               <span>Compose Email</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showBulkMessageComposer(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-message-draw</v-icon>
                </button>
              </template>
              <span>Compose SMS</span>
            </v-tooltip>
          </div>
          <router-link
            :to="{
              name: 'Dynamic Group Patients',
              params: { groupId: item.GroupID },
            }"
          >
            <v-btn color="primary" outlined x-small class="ml-4">
              View Patients
            </v-btn>
          </router-link>
          <v-btn
            color="primary"
            outlined
            x-small
            class="ml-4"
            @click="_editGroup(item)"
          >
            Edit
          </v-btn>
          <v-icon v-if="isAdmin" small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </div>
      </template>
      <template v-slot:no-data>
        <p class="mb-4 mt-4">No groups to display</p>
        <v-btn color="primary" outlined class="mb-4" @click="_initialize">
          Refresh
        </v-btn>
      </template>
    </v-data-table>

    <dynamic-group-add-edit-dialog
      :selected-group="groupDialog.selectedGroup"
      :is-visible="groupDialog.isVisible"
      :is-edit-mode="groupDialog.isEditMode"
      :senders="senders"
      :filterTypes="filterTypes"
      @on-submit="onGroupAddEditSubmit"
      @on-close="onGroupAddEditDimiss"
      @on-success="onGroupAddEditSuccess"
      @on-error="onGroupAddEditError"
    />

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <div class="py-3" />
  </v-container>
</template>

<script>
  /* eslint-disable */
import { ApiCalls } from "../../../../api-calls";
import EventEmitter from "../../../../utils/event-emitter";
import UserHelper from "../../../../utils/user-helper";

export default {
  components: {
    DynamicGroupAddEditDialog: () => import(
        "../dynamic-group-add-edit-dialog/dynamic-group-add-edit-dialog.vue"
      ),
  },
  data: () => ({
    headers: [
      { text: "Name", value: "Name" },
      { text: "Notes", value: "Notes" },
      { text: "Messages", value: "MessageCnt" },
      { text: "Filter", value: "filterName" },
      { text: "", value: "System" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    snackbar: false,
    notification: "Unknown",
    groups: [],
    filteredGroups: [],
    senders: [],
    filterTypes: [],
    isOverlayVisible: false,
    groupDialog: {
      isVisible: false,
      isEditMode: false,
      selectedGroup: null,
    },
    isAdmin: false,
    groupFilterTypeID: "",
    selectedFilterId: -1,
    selectedFilterType: "all",
    types: [
      {
        typeLabel: "All",
        value: "all",
      },
      {
        typeLabel: "User groups",
        value: "user",
      },
      {
        typeLabel: "System groups",
        value: "system",
      },
    ],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Group" : "Edit Group";
    },
  },

  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close();
    },
    selectedFilterId() {
      this._filterGroups();
    },
    selectedFilterType() {
      this._filterGroups();
    },
    '$store.state.posActivePractice': function () {
      this._initialize();
    },
  },

  async created() {
    this.isAdmin = UserHelper.checkIfHasPracticeAdminAccess();
    await this._initialize();
  },

  methods: {
    async _initialize() {
      if (this.$store.state.posActivePractice) {
        await this._loadFilters();
        await this._loadGroups();
        await this._loadSenders();
      }
    },
    async _loadGroups() {
      try {
        this.isOverlayVisible = true;
        const response = await ApiCalls.fetchDynamicGroups(this.$store.state.posActivePractice.value);
        this.groups =
          response && response.data && response.data.length
            ? response.data
            : [];
        // Add filter name on groups
        const idMappedFilters = {};
        this.filterTypes.forEach((f) => {
          idMappedFilters[f.GroupFilterTypeID] = f.GroupFilterType;
        });

        this.groups = this.groups.map((g) => ({
          ...g,
          filterName: `${idMappedFilters[g.GroupFilterTypeID]} `,
        }));
        this._filterGroups();
        // eslint-disable-next-line no-empty
      } catch (error) {
        this.groups = [];
      }
      this.isOverlayVisible = false;
    },
    _filterGroups() {
      this.filteredGroups = this.groups;
      console.log("this.selectedFilterId :>> ", this.selectedFilterId);
      if (this.selectedFilterId && this.selectedFilterId > -1) {
        // Filter by type
        this.filteredGroups = this.groups.filter(
          (g) => g.GroupFilterTypeID === this.selectedFilterId
        );
      }
      // Filter by user/system groups
      if (this.selectedFilterType && this.selectedFilterType !== "all") {
        // Filter
        this.filteredGroups = this.filteredGroups.filter((t) => (this.selectedFilterType === "system" ? t.System : !t.System));
      }
    },
    async _loadSenders() {
      try {
        this.isOverlayVisible = true;
        const response = await ApiCalls.fetchSenders(this.$store.state.posActivePractice.value);
        this.senders =
          response && response.data && response.data.length
            ? response.data.map((s) => ({
                text: s.senderName,
                value: s.senderID,
              }))
            : [];
      } catch (error) {
        this.senders = [];
      }
      this.isOverlayVisible = false;
    },
    async _loadFilters() {
      try {
        this.isOverlayVisible = true;
        const response = await ApiCalls.fetchDynamicGroupFilters();
        this.filterTypes =
          response && response.data && response.data.length
            ? response.data
            : [];
      } catch (error) {
        this.filterTypes = [];
      }
      this.isOverlayVisible = false;
    },
    updateSender(senderID) {
      this.selectedSenderID = senderID;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = {
          id: -1,
          name: "",
          members: "-",
          messages: "-",
        };
        this.editedIndex = -1;
        this.selectedSenderID = null;
        this.isFormDirty = false;
      });
    },
    async save() {
      if (!(this.editedItem.name && this.editedItem.name.length)) {
        this.notification = "Please provide a group name";
        this.snackbar = true;
        return;
      }
      if (!this.selectedSenderID) {
        this.notification = "Please select a sender";
        this.snackbar = true;
        return;
      }

      this.isOverlayVisible = true;
      // New group
      try {
        await ApiCalls.createGroup({
          Name: this.editedItem.name,
          SenderID: this.selectedSenderID,
          PracticeID: this.$store.state.posActivePractice.value,
        });
        await this._loadGroups();
      } catch (error) {
        this.notification = "Unable to create group";
        this.snackbar = true;
      }
      this.isOverlayVisible = false;
      this.close();
    },
    async deleteItem(item) {
      if (window.confirm("Are you sure you want to delete this group?")) {
        if (item.GroupID) {
          try {
            await ApiCalls.deleteGroup(item.GroupID);
            this.notification = "Group has been deleted";
            this.snackbar = true;
            await this._loadGroups();
          } catch (error) {
            this.notification = "Unable to delete the group";
            this.snackbar = true;
          }
        } else {
          this.notification = "Group id not available";
          this.snackbar = true;
        }
      }
    },
    _showAddGroupDialog() {
      this.groupDialog = {
        isVisible: true,
        isEditMode: false,
        selectedGroup: null,
      };
    },
    _showEditGroupDialog(group) {
      this.groupDialog = {
        isVisible: true,
        isEditMode: false,
        selectedGroup: group,
      };
    },
    _hideGroupDialog() {
      this.groupDialog = {
        isVisible: false,
        isEditMode: false,
        selectedGroup: null,
      };
    },
    onGroupAddEditSuccess() {
      this._hideGroupDialog();
      this._loadGroups();
    },
    onGroupAddEditDimiss() {
      this._hideGroupDialog();
      this.isOverlayVisible = false;
    },
    onGroupAddEditSubmit() {
      this.isOverlayVisible = true;
    },
    onGroupAddEditError() {
      this.isOverlayVisible = false;
    },
    _showBulkMessageComposer(group) {
      EventEmitter.dispatch("show-group-bulk-sms-composer", {
        selectedGroupType: "dynamic",
        selectedGroup: group,
      });
    },
    _showBulkEmailComposer(group) {
      EventEmitter.dispatch("show-group-bulk-email-composer", {
        selectedGroupType: "dynamic",
        selectedGroup: group,
      });
    },
    _showIvrCallInitiator(group) {
      EventEmitter.dispatch("show-group-bulk-ivr-composer", {
        selectedGroupType: "dynamic",
        selectedGroup: group,
      });
    },
    _editGroup(item) {
      this.groupDialog = {
        isVisible: true,
        isEditMode: true,
        selectedGroup: item,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import url("./manage-dynamic-groups.scss");
.filterSelector {
  width: 0px;
}
.senderActions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.commBtnWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.quick-comm-btn {
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  margin-right: 15px;
  align-items: center;
  background-color: rgb(0, 114, 44);
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.12);
  color: white;
  font-size: 12px;
  * {
    font-size: 12px;
    color: white;
  }
  border-radius: 100px;
}
.systemTemplateTicker {
  background-color: chocolate;
  border-radius: 25px;
  padding: 2px 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
  color: white;
}
.userTemplateTicker {
  background-color: rgb(30, 144, 210);
  border-radius: 25px;
  padding: 2px 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
  color: white;
}
.filterSelector {
  margin-right: 1rem;
}
</style>
